import { getHelpCenterUrl } from '@heidi/utils/help-center';

const BILLING_COLLECTION_PATH = 'collections/8147863-plans-pricing-billing';

const FREE_VS_PRO_PLANS_HELP_ARTICLE_PATH =
  'articles/8885030-free-vs-pro-plans-cost-subscription';

/** Anchored at the plan-comparison section, linked from upgrade prompts. */
export const FREE_VS_PRO_PLANS_ANCHOR_HELP_ARTICLE_PATH = `${FREE_VS_PRO_PLANS_HELP_ARTICLE_PATH}#h_584a797a6e`;

/** Anchored at the account/subscription section, linked from billing settings. */
export const FREE_VS_PRO_PLANS_ACCOUNT_ANCHOR_HELP_ARTICLE_PATH = `${FREE_VS_PRO_PLANS_HELP_ARTICLE_PATH}#h_d4f4861749`;

/** Anchored at the usage-limits section, linked from the bonus-usage banner. */
const USAGE_LIMITS_HELP_ARTICLE_PATH =
  'articles/17020377-how-do-usage-limits-work-on-clinician-and-practice-seats#h_d559b2941a';

const MARKETING_SITE_BASE = 'https://www.heidihealth.com';

export const getBillingHelpCentreUrl = (locale?: string): string =>
  getHelpCenterUrl(BILLING_COLLECTION_PATH, locale);
export const getUsageLimitsHelpUrl = (locale?: string): string =>
  getHelpCenterUrl(USAGE_LIMITS_HELP_ARTICLE_PATH, locale);
export const BILLING_PLANS_PRICING_URL = `${MARKETING_SITE_BASE}/pricing`;
export const GERMAN_BILLING_PLANS_PRICING_URL = `${MARKETING_SITE_BASE}/de-de/pricing`;
export const JAPANESE_BILLING_PLANS_PRICING_URL = `${MARKETING_SITE_BASE}/ja-jp/pricing`;
export const COMPARE_PLANS_URL = `${MARKETING_SITE_BASE}/pricing#pricing-table`;
export const GET_IN_TOUCH_URL = `${MARKETING_SITE_BASE}/contact`;
export const JAPANESE_GET_IN_TOUCH_URL = `${MARKETING_SITE_BASE}/ja-jp/contact`;
export const CONTACT_SALES_URL = `${MARKETING_SITE_BASE}/contact-sales`;
/**
 * Contact-sales URL prefilled with the `practice` pricing-plan query so the
 * marketing form lands pre-scoped to Practice. Used by the trial-ended
 * modal's "Remain on Scribe Team" CTA for admins — they're not upgrading
 * right now but a sales conversation can keep the door open.
 */
export const CONTACT_SALES_PRACTICE_URL = `${CONTACT_SALES_URL}?pricing_plan=practice`;

const toMarketingSiteLocale = (locale?: string) =>
  locale?.toLowerCase().replace(/_/g, '-');

export const getBillingPlansPricingUrl = (locale?: string) => {
  const marketingSiteLocale = toMarketingSiteLocale(locale);
  if (!marketingSiteLocale) return BILLING_PLANS_PRICING_URL;
  return `${MARKETING_SITE_BASE}/${marketingSiteLocale}/pricing`;
};

export const getComparePlansUrl = (locale?: string) =>
  `${getBillingPlansPricingUrl(locale)}#pricing-table`;

export const getGetInTouchUrl = (locale?: string) => {
  const marketingSiteLocale = toMarketingSiteLocale(locale);
  if (marketingSiteLocale === 'ja-jp') return JAPANESE_GET_IN_TOUCH_URL;
  return GET_IN_TOUCH_URL;
};
